import man from "../assets/images/group/man.png";
import FoodTypeIcon from "./FoodTypeIcon";

type Props = {
  image: string;
  itemName: string;
  itemPrice: number;
  discountedPrice: number;
  quantity: string;
  addedBy: string;
  onCountChange?: (count: number) => void;
  foodType?: string | { name?: string } | null;
};

const GroupOrderedItem = ({
  image,
  itemName,
  itemPrice,
  discountedPrice,
  quantity,
  addedBy,
  foodType,
}: Props) => {
  return (
    <div className="py-[20px] border-b-2 dark:border-gray-700 border-dashed transition-colors duration-300">
      <div className="flex justify-between items-center">
        <div className="flex gap-[20px] items-center">
          <div className="flex items-center gap-4">
            <img
              src={image}
              alt="Food Item"
              className="h-[75px] w-[75px] rounded-[12px]"
            />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <FoodTypeIcon foodType={foodType} size={14} />
              <p className="text-[#050505] dark:text-white font-urbanist text-[25px] font-medium leading-[25px]">
                {itemName}
              </p>
            </div>
            <p className="text-[#7402A7] dark:text-purple-400 font-urbanist text-[18px] font-medium leading-[22px]">
              {discountedPrice}{" "}
              <span className="line-through text-[#6A6A6A] dark:text-gray-400 ml-[15px]">
                {itemPrice}
              </span>
            </p>
            <p className="text-[#050505] dark:text-gray-300 font-urbanist text-[15px] font-normal leading-[22px]">
              {quantity}
            </p>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-3">
            <img src={man} alt="Added by" className="h-[20px] w-[20px]" />
            <p className="text-[#6A6A6A] dark:text-gray-400 font-urbanist text-[14px] font-medium leading-[20px]">
              Added by {addedBy}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupOrderedItem;
